import { APIClient } from "./api_helper";

import * as url from "./url_helper";

const api = new APIClient();

export const createTipPayment = (eventId, data) => {
  return api.create(`/guest/events/${eventId}/tips`, {
    amount: data.amount,
    guestName: data.guestName,
    guestEmail: data.guestEmail,
    // Co serwer ma dodać po opłaceniu (utwór/dedykacja) — trafia w metadane PaymentIntent.
    pendingAction: data.pendingAction,
  });
};

export const postTipNotify = (eventId, data) => {
  return api.create(`/guest/events/${eventId}/tips/notify`, data);
};

export const getTipList = () => {
  return api.get('/tips/me');
};

// Widok głównego administratora — napiwki wskazanego club admina
export const getUserTips = (userId) => api.get(url.GET_USER_TIPS(userId));

export const markUserTipsPaid = (userId, ids = null) =>
  api.create(url.POST_MARK_USER_TIPS_PAID(userId), ids ? { ids } : {});

export const patchTipStatus = (id, status) => api.update(url.PATCH_TIP(id), { status });
